import React, { useMemo } from "react";

const Couponissuedtb = ({ data }) => {
    const tableData = useMemo(() => {
        return data?.map((item, index) => ({
            srNo: index + 1,
            chassisNo: item.chassisNo || "-",
            totalAmount: item.total_cupon_amount_generated?.Total_amount_coupon_generated?.value || 0,
            totalAvailed: item.total_amout_coupon_vailed?.Total_amount_coupon_availed?.value || 0,
            balance: item.total_amount_coupon_balance_active?.groupby?.buckets?.all?.Total_amount_coupon_Balance_Active?.value || 0,
            expired: item.total_amount_coupon_expired?.Total_amount_coupon_expired?.value || 0,
        })) || [];
    }, [data]);

    if (!tableData.length) {
        return <p className="text-center text-gray-500 py-4">No data available</p>;
    }

    return (
        <div className="overflow-x-auto border rounded-lg shadow-md">
            <table className="min-w-full border-collapse">
                <thead className=" text-white sticky top-0 bg-[#267CB8]">
                    <tr>
                        <th className="px-4 py-2 border-b text-left">Sr No</th>
                        <th className="px-4 py-2 border-b text-left">Chassis No</th>
                        <th className="px-4 py-2 border-b text-right">Total Coupon Amount</th>
                        <th className="px-4 py-2 border-b text-right">Total Availed</th>
                        <th className="px-4 py-2 border-b text-right">Balance</th>
                        <th className="px-4 py-2 border-b text-right">Expired</th>
                    </tr>
                </thead>
                <tbody>
                    {tableData.map((row, idx) => (
                        <tr
                            key={row.srNo}
                            className={idx % 2 === 0 ? "bg-white" : "bg-gray-50 hover:bg-gray-100"}
                        >
                            <td className="px-4 py-2 border text-left">{row.srNo}</td>
                            <td className="px-4 py-2 border text-left">{row.chassisNo}</td>
                            <td className="px-4 py-2 border text-right">{row.totalAmount.toLocaleString()}</td>
                            <td className="px-4 py-2 border text-right">{row.totalAvailed.toLocaleString()}</td>
                            <td className="px-4 py-2 border text-right">{row.balance.toLocaleString()}</td>
                            <td className="px-4 py-2 border text-right">{row.expired.toLocaleString()}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Couponissuedtb;
